// extracted by mini-css-extract-plugin
module.exports = {"listDiv":"bussinessList_listDiv__3w8EO","listTitleSty":"bussinessList_listTitleSty__16Bxh"};